

import { API } from 'aws-amplify';
class UsersService {
    getUsers = async (airlineCode) => {
        var ReturnObj = [];
        await API.get('IAPI', 'Users/regulars/', {
            'queryStringParameters': {
                'AirlineCode': airlineCode
            }
        })
            .then((res) => {
                ReturnObj = res;                
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }
    getAdmins = async () => {
        var ReturnObj = [];
        
        await API.get('IAPI', 'Users/admins/')
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }
    addUser = async (user) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                AirlineCode: user.AirlineCode,
                Role: user.Role,
                LastName: user.LastName,
                FirstName: user.FirstName,
                UserName: user.UserName,
                PhoneNumber: user.PhoneNumber,
                FaxNumber: user.FaxNumber,
            }
        }

        await API.post('IAPI', 'Users/add/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }

    addAdmin = async (user) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                AirlineCode: user.AirlineCode,
                Role: user.Role,
                LastName: user.LastName,
                FirstName: user.FirstName,
                UserName: user.UserName,
                PhoneNumber: user.PhoneNumber,
                FaxNumber: user.FaxNumber,
            }
        }

        await API.post('IAPI', 'Users/addAdmins/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }
    updateUser = async (user) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                AirlineCode: user.AirlineCode,
                Role: user.Role,
                LastName: user.LastName,
                FirstName: user.FirstName,
                UserName: user.UserName,
                PhoneNumber: user.PhoneNumber,
                FaxNumber: user.FaxNumber,
            }
        }
        await API.post('IAPI', 'Users/update/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }

    deleteUser = async (user) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                AirlineCode: user.airlineCode,
                Role: user.role,
                LastName: user.lastName,
                FirstName: user.firstName,
                UserName: user.userName,
                PhoneNumber: user.phoneNumber,
                FaxNumber: user.faxNumber,
            }
        }

        await API.post('IAPI', 'Users/Remove/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }

    updateAdmin = async (user) => {
        var ReturnObj = {};
        var myInit = {
            body: {
                AirlineCode: user.AirlineCode,
                Role: user.Role,
                LastName: user.LastName,
                FirstName: user.FirstName,
                UserName: user.UserName,
                PhoneNumber: user.PhoneNumber,
                FaxNumber: user.FaxNumber,
            }
        }
        await API.post('IAPI', 'Users/updateAdmin/', myInit)
            .then((res) => {
                ReturnObj = res;
                return res;
            }).catch((error) => {
                return error;
            }
            );
        return ReturnObj;
    }
}

export default new UsersService();